<template>
  <div class="box-bank">
    <div class="box-title">
      <div class="text">Cập Nhật tài khoản ngân hàng</div>
    </div>
    <div class="content-box">
      <b-form @submit.prevent="onUpdateBank">
        <b-form-group>
          <label for="">Tên Ngân Hàng</label>
          <b-form-select
            class="text-white"
            v-model="bank.bankcard"
            :options="BankList"
            value-field="id"
            text-field="name"
            :class="{
              'is-invalid': submitted && $v.bank.bankcard.$error,
            }"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                <span class="font-size-10">
                  Vui Lòng Chọn Ngân Hàng
                </span>
              </b-form-select-option>
            </template>
          </b-form-select>
          <div
            v-if="submitted && !$v.bank.bankcard.required"
            class="invalid-feedback"
          >
            Đây là trường bắt buộc
          </div>
        </b-form-group>
        <b-form-group>
          <label for="">Chủ Tài Khoản</label>
          <b-form-input
            v-model="bank.bank"
            :class="{
              'is-invalid': submitted && $v.bank.bank.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.bank.bank.required"
            class="invalid-feedback"
          >
            Đây là trường bắt buộc
          </div>
          <div
            v-if="submitted && !$v.bank.bank.onlyText"
            class="invalid-feedback"
          >
            Vui Lòng nhập đúng họ và tên không dấu in trên thẻ, hãy đảm bảo rằng
            khoảng chống giữa các ký không quá 1
          </div>
        </b-form-group>
        <b-form-group>
          <label for="">Số Tài Khoản </label>
          <b-form-input
            v-model="bank.banknumber"
            :class="{
              'is-invalid': submitted && $v.bank.banknumber.$error,
            }"
          ></b-form-input>
          <div
            v-if="submitted && !$v.bank.banknumber.required"
            class="invalid-feedback"
          >
            Đây là trường bắt buộc
          </div>
        </b-form-group>
        <div class="form-group d-flex justify-content-center">
          <b-button class="mx-auto mt-3" variant="primary" type="submit">
            Cập Nhật
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { required, helpers } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
const onlyText = helpers.regex("alphaNumAndDot", /^([A-Za-z]+\s)*[A-Za-z]+$/);
export default {
  data() {
    return {
      bank: {
        bankcard: null,
        bank: null,
        banknumber: null,
        type: 1,
      },
      show1: false,
      show2: false,
      show3: false,
      submitted: false,
    };
  },
  validations: {
    bank: {
      bankcard: {
        required,
      },
      bank: {
        required,
        onlyText,
      },
      banknumber: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters({
      BankList: "investment/BankList",
      MileStone: "investment/MileStone",
      Bank: "user/Bank",
    }),
  },
  watch: {
    Bank: {
      handler() {
        this.bank = {
          bankcard: this.Bank.bankcard.id,
          bank: this.Bank.bank,
          banknumber: this.Bank.banknumber,
          type: 1,
        };
      },
    },
  },
  methods: {
    onUpdateBank() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.$store.dispatch("user/req_postUpdateBank", this.bank);
    },
  },
  created() {
    this.$store.dispatch("user/req_getInfoBank");
    this.$store.dispatch("investment/req_getBankList");
  },
};
</script>

<style lang="scss">
.box-bank {
  width: 100%;
  min-height: 50px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 1.25rem;
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
    padding: 0 1.25rem;
    background-color: #ffff;
    border-radius: 10px 10px 10px 10px;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.305);
    .text {
      color: #000;
      font-weight: 600;
      font-size: 20px;
      text-transform: capitalize;
      .text-warning {
        font-size: clamp(15px, 2vw, 16px);
      }
    }
    .icon {
      cursor: pointer;
      img {
        height: 20px;
        width: auto;
      }
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .content-box {
    padding: 1.25rem;
    .warning-changepass {
      font-weight: 700;
      color: darkorange;
      font-size: clamp(13px, 1vw, 14.2px);
      margin-bottom: 15px;
      text-transform: capitalize;
      text-align: center;
    }
    .form-group {
      max-width: 690px;
      margin: 0 auto 10px;
      label {
        font-weight: 600;
        color: #ffff;
        font-size: 16px;
        margin-top: 15px;
      }
      .input-group-text {
        background: transparent;
        padding: 0;
        border: 1px solid #e9ecef;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      select,
      input {
        width: 100%;
        border: 1px solid #e9ecef;
        height: 40px;
        font-size: clamp(13px, 1vw, 14.2px);
        font-weight: 600;
        background: #fff;
        border-radius: 5px;
        padding-left: 5px;
        color: #000!important;
        &:focus {
          box-shadow: 0 0 0 1px rgba(56, 169, 73, 45%);
        }
        &::placeholder {
          font-weight: 500;
          font-size: clamp(13px, 1vw, 15px);
        }
      }
    }
  }
}
</style>
